import { store } from '../../store.js'
import axios from "../../plugins/axios.js"
import { NULL_AVATAR } from '@/constant.js'
import { createFormData, getSSRdata } from '../../utils/utils.js';

store.registerModule('$user', {
    namespaced: true,
    state: {
        username: "",
        userid: -1,
        avatarURL: NULL_AVATAR,
        followees: 0,
        followers: 0,
        hasFollow: false,
        score: 0,
        top: 0,
        win: 0,
        tower: 0,
        comment: 0,
        achievement: [],
        isSponsor: false,
        noFound: false,
        sign: '',
    },
    mutations: {
        fetchUserInfo(state) {
            const data = getSSRdata("detail");
            if (data.code == 0) {
                for (let key in data) {
                    if (key in state) {
                        state[key] = data[key];
                    }
                }
                if (!state.avatarURL) state.avatarURL = NULL_AVATAR;
            } else { // 无数据时为空页面
                state.noFound = true;
            }
        },
        follow(state, opt) {
            state.hasFollow = opt;
            if (opt) {
                state.followers++;
            } else {
                state.followers--;
            }
        }
    },
    actions: {
        async follow({ commit, state }, opt) {
            const { data } = await axios.post(`/backend/user/follow.php`, createFormData({
                    type: opt ? "follow" : "unfollow", target: state.userid
                }));
            if (data.code == 0) {
                commit("follow", opt);
            }
        }
    }
})